import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { defaultRefinePages, fetchRefinePages } from "../utilis/refinePages";

const Craft = ({ userData }) => {
  const navigate = useNavigate();
  const [crafts, setCrafts] = useState(defaultRefinePages);

  useEffect(() => {
    let active = true;

    fetchRefinePages()
      .then((pages) => {
        if (active) setCrafts(pages);
      })
      .catch(() => {
        if (active) setCrafts(defaultRefinePages);
      });

    return () => {
      active = false;
    };
  }, []);

  const handleClick = () => {
    navigate("/register");
  };

  return (
    <section className="main-craft py-[80px] ">
      <div className="bg-[#5D260E80] py-[80px] px-[1rem] rounded-[30px]">
        <div className="container m-auto text-center">
          <h2 className="text-white font-cinzel text-[40px] lg:text-[80px] mb-[50px]">
            Refine Your Craft
          </h2>

          <Row gutter={[24, 24]} align="middle" justify="center">
            {crafts.map((item, index) => {
              const bgImage = item.image;

              return (
                <Col key={index} xs={24} sm={24} md={8}>
                  <button
                    type="button"
                    onClick={() => navigate(userData ? `/refine/${item.slug || item.id}` : "/register")}
                    className="relative group flex flex-col justify-center items-center rounded-xl overflow-hidden 
                     transition-all duration-500 ease-out cursor-pointer w-full text-left focus:outline-none focus:ring-4 focus:ring-cyan-300"
                    style={{
                      backgroundImage: `url(${bgImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      minHeight: "35vh",
                    }}
                  >
                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black/40 transition-all duration-500 group-hover:bg-black/60"></div>

                    {/* Image Zoom */}
                    <div
                      className="absolute inset-0 transition-all duration-700 group-hover:scale-110"
                      style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />

                    {/* Preview overlay when not logged in */}
                    {!userData && (
                      <div className="relative z-10 text-center px-4 py-8 transition-all duration-500 group-hover:-translate-y-2">
                        <FaLock className="text-white block m-auto text-[20px] mb-3" />
                        <p className="text-white font-outfit text-sm md:text-base">
                          This is just a preview. Become a member to explore
                          Refine resources, learning paths, and mentor guidance.
                        </p>
                      </div>
                    )}

                    {userData && (
                      <div className="relative z-10 mt-auto w-full px-5 pb-6 pt-20 text-white">
                        <p className="font-outfit text-sm leading-6">{item.detail}</p>
                        <p className="mt-4 font-outfit text-xs font-semibold uppercase tracking-[0.18em] text-[#00F0FB]">
                          View details
                        </p>
                      </div>
                    )}
                  </button>

                  {/* Title */}
                  <h2 className="text-black font-cinzel text-[22px] md:text-[25px] mt-5 text-center">
                    {item.title}
                  </h2>
                </Col>
              );
            })}
          </Row>
          {!userData && (
            <button
              className="mt-[45px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
             shadow-md transition-all duration-500 hover:-translate-y-1 
             hover:shadow-lg hover:text-black"
              style={{
                background:
                  "linear-gradient(29deg, rgba(0,240,251,1) 0%, rgba(255,255,255,1) 50%, rgba(0,240,251,1) 100%)",
                backgroundSize: "200% 200%",
                transition: "all 0.6s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundPosition = "right center";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundPosition = "left center";
              }}
              onClick={handleClick}
            >
              Unlock Resources \ Become a Member
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Craft;
